module.exports = __webpack_public_path__ + "static/media/hubtel_loader.eac3314a.gif";